/**
 * Cookie banner text reducer.
 * @module reducers/cookieBannerReducer
 */

import {
  CLOSE_MANAGE_COOKIES,
  GET_HTML_DOMAINS,
  OPEN_MANAGE_COOKIES,
} from '../actions';

const initialState = {
  modalOpen: false,
};

export const manageCookies = (state = initialState, action = {}) => {
  switch (action.type) {
    case OPEN_MANAGE_COOKIES:
      return {
        ...state,
        modalOpen: true,
      };

    case CLOSE_MANAGE_COOKIES:
      return {
        ...state,
        modalOpen: false,
      };

    default:
      return state;
  }
};

const htmlDomainsInitialState = {
  domainsWithConsent: [],
  domainsWithoutConsent: [],
  error: null,
  loaded: false,
  loading: false,
};

/**
 * HTML domains reducer.
 * @function htmlDomains
 * @param {Object} state Current state.
 * @param {Object} action Action to be handled.
 * @returns {Object} New state.
 */
export const htmlDomains = (state = htmlDomainsInitialState, action = {}) => {
  switch (action.type) {
    case `${GET_HTML_DOMAINS}_PENDING`:
      return {
        ...state,
        error: null,
        loading: true,
        loaded: true,
      };

    case `${GET_HTML_DOMAINS}_SUCCESS`:
      return {
        ...state,
        domainsWithConsent: action.result?.domains_with_consent || [],
        domainsWithoutConsent: action.result?.domains_without_consent || [],
        error: null,
        loading: false,
        loaded: true,
      };

    case `${GET_HTML_DOMAINS}_FAIL`:
      return {
        ...state,
        error: action.error,
        loading: false,
        loaded: true,
      };

    default:
      return state;
  }
};
